const URL = " https://dplanitplus.dplanit.co.kr";
// const URL = "http://localhost:8081";


export { URL };
